<form id="permanent_planning_event" [formGroup]="this.permanentPlanningEventForm" (ngSubmit)="this.saveEvent()">
    
    <div class="title_card">{{'EVENT' | translate}}</div>    
    
    @if(this.isFetching || this.isFetchingEvent){
        <div class="bloc_loading">
            <ion-spinner></ion-spinner>
        </div> 
    }
    @else{    
        <div id="permanent_planning_event_form">

            <marv-input-date label="{{ 'START_DATE' | translate }}" formName="startDate" [withSpeechToText]="true" [disabled]="this.event?.allowToUpdate === false" class="field_date"/>
            <marv-input-time label="{{ 'START_HOUR' | translate }}" icon="time-outline" formName="startHour" [disabled]="this.event?.allowToUpdate === false" class="field_date"/>
            <marv-select label="{{ 'DURATION' | translate }}" icon="hourglass-outline" formName="duration" [items]="this.durations" [withSearch]="false" [disabled]="(this.permanentPlanningEventForm.controls['allDay'].value || this.event?.allowToUpdate === false)" class="field_date"></marv-select>
            <marv-toggle label="{{'ALL_DAY_EVENT' | translate}}" formName=allDay labelPlacement="end" [disabled]="this.event?.allowToUpdate === false" class="field_date"/>

            <marv-select label="{{ 'AGENTS' | translate }}" icon="person-outline" formName="agentsId" [items]="this.agentsItems" [multiple]="true" [disabled]="this.event?.allowToUpdate === false"></marv-select> 

            <marv-select label="{{ 'EVENT_TYPE' | translate }}" icon="newspaper-outline" formName="eventType" [items]="this.eventsTypes" [withSpeechToText]="true" [disabled]="this.event?.allowToUpdate === false"></marv-select>
            <marv-textarea label="{{ 'DESCRIPTION' | translate }}" icon="information-circle-outline" formName="description" [fixedLabel]="true" [withSpeechToText]="true" [disabled]="this.event?.allowToUpdate === false"/>
        </div>

        <ion-grid id="footer_permanent_planning_event">
            <ion-row class="ion-justify-content-around">
                @if(this.event === null || this.event.allowToUpdate){
                    <ion-col size="auto">
                        <marv-button type="submit" label="{{ 'SAVE' | translate }}" icon="checkmark-outline" color="primary" [isFetching]="this.isFetchingSave"/>
                    </ion-col>

                }
                @if(this.event != null && this.event.allowToDelete){
                    <ion-col size="auto">
                        <marv-button type="button" label="{{ 'DELETE' | translate }}" icon="trash-outline" color="red" [isFetching]="this.isFetchingDelete" (click)="this.confirmDelete()"/>
                    </ion-col>

                }
                <ion-col size="auto">
                    <marv-button type="button" label="{{ 'CANCEL' | translate }}" icon="close-outline" color="secondary" (click)="this.cancel()" />
                </ion-col>
            </ion-row>
        </ion-grid>
    }
</form>